import { useCallback, useEffect, useState } from 'react';
import { StyleSheet, TextInput, View } from 'react-native';
import { useFocusEffect } from '@react-navigation/native';
import { Text } from '@/components/Text';
import { checkPassword } from '../api/services/user';
import colors, { appTheme } from '@/config/colors';
import { PressableNeolexon } from '@/components/PressableNeolexon';
import { useSidebarAnimation } from '@/components/ui/therapist/CollapsibleSidebar/SidebarAnimationContext';

export default function PasswordUnlock(props) {
  const [password, setPassword] = useState('');
  const [showPasswordError, setShowPasswordError] = useState(false);
  const { setShowHeader } = useSidebarAnimation();

  const onChange = useCallback((value) => {
    setPassword(value);
  }, []);

  const onSubmit = useCallback(async (value) => {
    const res = await checkPassword(value);
    if (res === 200) {
      setPassword('');
      props.navigation.reset({
        index: 0,
        routes: [{ name: 'Home' }],
      });
      setShowHeader(true);
    } else {
      setShowPasswordError(true);
    }
  }, []);

  useFocusEffect(
    useCallback(() => {
      setShowHeader(false);
    }, []),
  );

  useEffect(() => {
    // to remove the blocker from going back that is used in CheckPassword if the user entered using password and not patternlock
    props.navigation.addListener('beforeRemove', (e) => {
      props.navigation.dispatch(e.data.action);
    });
  }, []);

  return (
    <View style={styles.container}>
      <View style={styles.title_container}>
        <Text style={styles.title_top}>Passwort eingeben</Text>
      </View>
      <View style={styles.body}>
        <Text style={styles.title_body}>
          Bitte geben Sie hier Ihr Passwort ein, um den Bildschirm zu
          entsperren.
        </Text>
        <View style={styles.action}>
          <TextInput
            autoComplete="off"
            style={styles.input}
            onChangeText={onChange}
            value={password}
            placeholder="Passwort"
            secureTextEntry
          />
          {showPasswordError ? (
            <View style={styles.password_container}>
              <Text style={styles.password_title}>Falsches Passwort</Text>
            </View>
          ) : null}
          <PressableNeolexon
            style={styles.body_button}
            onPress={() => onSubmit(password)}
          >
            <Text style={styles.title_action}>entsperren</Text>
          </PressableNeolexon>
        </View>
      </View>
      <PressableNeolexon
        onPress={() => props.navigation.goBack()}
        style={styles.button_container}
      >
        <Text style={styles.title_bottom}>Zurück zum Sperrmuster</Text>
      </PressableNeolexon>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.black,
  },
  title_container: {
    width: '100%',
    paddingTop: 10,
  },
  title_top: {
    fontSize: 18,
    fontWeight: '700',
    color: colors.white,
    textAlign: 'center',
  },
  button_container: {
    width: '100%',
    paddingBottom: 20,
  },
  title_bottom: {
    fontSize: 16,
    fontWeight: '700',
    color: colors.white,
    textAlign: 'center',
  },
  body: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  title_body: {
    fontSize: 20,
    fontWeight: '700',
    color: colors.white,
    textAlign: 'center',
  },
  action: {
    paddingTop: 20,
    width: '100%',
    maxWidth: 350,
  },
  body_button: {
    backgroundColor: colors.white,
    borderRadius: 4,
    padding: 10,
  },
  title_action: {
    fontSize: 22,
    fontWeight: '700',
    color: appTheme.textColor,
    textAlign: 'center',
  },
  input: {
    marginVertical: 12,
    borderWidth: 1,
    borderRadius: 4,
    backgroundColor: colors.white,
    color: colors.black,
    padding: 10,
  },
  password_container: {
    marginBottom: 12,
  },
  password_title: {
    color: colors.red,
    textAlign: 'center',
    fontSize: 20,
    fontWeight: '700',
  },
});
